import React from 'react';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import themeSVG from '@plone/volto/icons/theme.svg';

export default function addStyleMenuTextColors(config) {
  const { slate } = config.settings;

  slate.styleMenu = slate.styleMenu || {};
  slate.styleMenu.inlineStyles =
    slate.styleMenu.inlineStyles || [];

  slate.styleMenu.inlineStyles.push(
    {
      cssClass: 'text-color-primary',
      label: 'Primary',
      icon: () => (
        <Icon name={themeSVG} size="24px" />
      ),
    },
    {
      cssClass: 'text-color-success',
      label: 'Success',
      icon: () => (
        <Icon name={themeSVG} size="24px" />
      ),
    },
    {
      cssClass: 'text-color-warning',
      label: 'Warning',
      icon: () => (
        <Icon name={themeSVG} size="24px" />
      ),
    },
    {
      cssClass: 'text-color-danger',
      label: 'Danger',
      icon: () => (
        <Icon name={themeSVG} size="24px" />
      ),
    },
    {
      cssClass: 'text-color-muted',
      label: 'Muted',
      icon: () => (
        <Icon name={themeSVG} size="24px" />
      ),
    },
  );

  return config;
}